module.exports = __webpack_public_path__ + "static/media/screen-behavioral-02.25e02727.jpg";